<template>
  <header class="calc-header">
    <div class="calc-header__container">
      <div class="calc-header__first">
        <a href="https://new.banki/shop" class="calc-header__logo">
          <img src="https://new.banki.shop/img/Logo-mobile.44de94a8.svg" alt="banki.shop" />
        </a>
        <div class="calc-header__switch switch">
          <button 
            class="switch__item" 
            :class="{'switch__item--active': mode === 'quiz'}"
            @click="$emit('mode', 'quiz')"
          >
            Опрос
          </button>
          <div class="switch__divider"></div>
          <button 
            class="switch__item"
            :class="{'switch__item--active': mode === 'calc'}"
            @click="$emit('mode', 'calc')"
          >
            Калькулятор
          </button>
          <button class="switch__item switch__question">?</button>
        </div>
      </div>
      <div class="calc-header__last">
        <!-- <div class="count">
          <div class="count__title">Отфильтровано:</div>
          <div class="count__icon"><img src="/assets/icons/svg/bank.svg" alt="Bank"></div>
          <div class="count__value">15</div>
        </div>
        <div class="count__divider" /> -->
        <div v-if="count > 0" class="count">
          <div class="count__title">Банков / Партнеров:</div>
          <div class="count__icon">
            <IconBank />
          </div>
          <div class="count__value count__value--primary">{{ count }}</div>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconBank from '../shared/IconBank.vue';

export default defineComponent({
  components: {
    IconBank
  },
  props: {
    count: {
      type: Number,
      default: 0,
    },
    mode: {
      type: String,
      required: true,
    }
  },
})
</script>

<style lang="scss" scoped>
.calc-header {
  width: 100%;
  border-bottom: 1px solid #969897;

  &__container {
    width: 100%;
    height: 68px;
    padding: 0 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__first {
    display: flex;
    gap: 32px;
  } 
  
  &__last {
    display: flex;
    gap: 16px;
  }

  &__logo {
    display: flex;
    align-items: center;
    width: 163px;

    img {
      width: 100%;
    }
  }

   &__counts {
    display: flex;
    align-items: center;
    gap: 16px;
  }
}

.switch {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 12px;

  &__item {
    font-size: 14px;
    background-color: transparent;
    color: #777;
    border: none;
  }

  &__item--active {
    color: #000;
  }

  &__divider {
    height: 16px;
    border-right: 1px solid #AAA;
  }

  &__question {
    font-size: 18px;
    color: var(--main-color);
  }
}


.count {
  display: flex;
  gap: 8px;
  align-items: center;

  &__title {
    font-size: 16px;
  }

  &__icon {
    height: 100%;
    display: flex;
    align-items: center;
    display: none;
  }

  &__value {
    font-size: 24px;
    color: #777777;
    font-weight: 700;
  }

  &__value--primary {
    color: var(--main-color);
  }

  &__divider {
    height: 32px;
    border-right: 1px solid #AAA;
  }
}

@container bank-card (min-width: 800px) and (max-width: 949px) {
  .calc-header{
    &__first {
      gap: 24px;
    }

    &__last {
      gap: 12px;;
    }
  }
}

@container bank-card (max-width: 799px) {
  .calc-header {
    &__logo {
      width: 129px;
    }
  }

  .count {
    &__icon {
      display: flex;
    }

    &__divider {
      display: none;
    }

    &__title {
      display: none;
    }

    &__value {
      font-weight: 400;
      font-size: 18px;
    }
  }
}

@container bank-card (max-width: 600px) {
  .calc-header {
    &__logo {
      display: none;
    }
  }

  .switch {
    &__divider {
      display: none;
    }

    &__question {
      display: none;
    }
  }

  .count {
    &__value {
      font-size: 16px;
    }
  }
}
</style>
